/*! COURT7 — Gratis-Geschenk ab Warenkorb-Schwelle
 *  Aktion: COURT7 Sportflasche gratis ab 50 EUR (06.09.–13.09.2026)
 *
 *  WAS DAS SKRIPT MACHT
 *  Sobald der qualifizierende Warenkorbwert die Schwelle erreicht, legt es die
 *  Geschenk-Variante in den Warenkorb; faellt der Wert darunter, nimmt es sie
 *  wieder heraus. Dazu zeigt es einen Fortschrittsbalken ("Noch X EUR bis zur
 *  Gratis-Flasche") oberhalb des Gratis-Versand-Balkens.
 *
 *  SICHERHEITSMODELL — wichtig beim Weiterentwickeln
 *  Kostenlos wird die Flasche AUSSCHLIESSLICH durch den automatischen
 *  Shopify-Rabatt (Buy-X-Get-Y, serverseitig). Dieses Skript legt sie nur in den
 *  Warenkorb. Nach jedem Hinzufuegen wird geprueft, ob der Rabatt wirklich
 *  gegriffen hat (final_line_price === 0). Wenn nicht — Aktion abgelaufen, Rabatt
 *  deaktiviert, Schwelle serverseitig anders bewertet — fliegt die Flasche sofort
 *  wieder heraus und das Skript haelt still. Damit kann niemand versehentlich
 *  20 EUR fuer eine Flasche zahlen, die er nie bestellt hat, und ein manipulierter
 *  Client bekommt nichts geschenkt.
 *
 *  Quelle: infra/.integration/court7/theme/court7-gift.js
 *  Deploy: theme_files_upsert -> assets/court7-gift.js (Venue, Theme 181167194491)
 */
import Cart from "cart-store";

const CFG = Object.assign(
  {
    // COURT7 Sportflasche, SKU BO-SC-01-BLU-1L
    variantId: 55526246908283,
    thresholdCents: 5000,
    // Aktionsfenster. Ausserhalb macht das Skript nichts: vor dem Start
    // verspricht der Fortschrittsbalken sonst etwas, das der Rabatt noch nicht
    // einloest, nach dem Ende schuetzt es davor, den Ausbau zu vergessen.
    // KEIN Sicherheitsmerkmal — die Client-Uhr ist nicht vertrauenswuerdig;
    // dafuer ist die Server-Verifikation da.
    // Aktion laeuft seit 06.09.2026 mittags (auf Wunsch vorgezogen, nicht erst
    // zum Drop um 19:00). startsAt bleibt leer, damit die Client-Uhr keine Rolle
    // spielt; das Ende steht doppelt (hier und im Rabatt).
    startsAt: null,
    endsAt: "2026-09-13T19:00:00+02:00",
    giftProperty: "_c7_gift",
    giftTag: "bottle-2026-09",
    labelProgress: "Geben Sie {amount} mehr aus, um die Gratis-Flasche zu erhalten.",
    labelReached: "Geschafft! Die COURT7 Sportflasche liegt gratis im Warenkorb.",
  },
  window.COURT7_GIFT || {}
);

const STOP_KEY = "c7GiftDisabled";

let working = false;
let disabled = false;

/* ---------------------------------------------------------------- helpers -- */

function outsideWindow() {
  const now = Date.now();
  const start = CFG.startsAt ? Date.parse(CFG.startsAt) : NaN;
  const end = CFG.endsAt ? Date.parse(CFG.endsAt) : NaN;
  if (Number.isFinite(start) && now < start) return true;
  if (Number.isFinite(end) && now > end) return true;
  return false;
}

function stopped() {
  if (disabled || outsideWindow()) return true;
  try {
    return sessionStorage.getItem(STOP_KEY) === "1";
  } catch (e) {
    return false;
  }
}

function stop(reason) {
  disabled = true;
  try {
    sessionStorage.setItem(STOP_KEY, "1");
  } catch (e) {
    /* private mode — in-memory flag genuegt */
  }
  if (window.console && console.info) {
    console.info("[COURT7 gift] deaktiviert:", reason);
  }
}

function findGift(cart) {
  const items = (cart && cart.items) || [];
  return items.find(
    (i) => i.properties && i.properties[CFG.giftProperty] === CFG.giftTag
  );
}

/** Warenkorbwert OHNE die Geschenk-Zeile — sonst haelt sich das Geschenk selbst
 *  ueber der Schwelle, sobald der Kunde andere Artikel entfernt. */
function qualifyingCents(cart) {
  const items = (cart && cart.items) || [];
  const gift = findGift(cart);
  return items.reduce((sum, i) => {
    if (gift && i.key === gift.key) return sum;
    const price = typeof i.final_line_price === "number" ? i.final_line_price : i.line_price;
    return sum + (price || 0);
  }, 0);
}

function money(cents) {
  const fmt = (window.theme && window.theme.money_format) || "";
  const whole = Math.ceil(cents / 100);
  // Venue rechnet im Shop ohne Dezimalstellen (money_format: EUR{{amount_no_decimals}})
  if (fmt.indexOf("no_decimals") !== -1) return "€" + whole;
  return "€" + (cents / 100).toFixed(2).replace(".", ",");
}

async function fetchCart() {
  const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
  if (!res.ok) throw new Error("/cart.js -> HTTP " + res.status);
  return res.json();
}

async function cartRequest(path, body) {
  const res = await fetch(path, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(path + " -> HTTP " + res.status);
  return res.json();
}

/* -------------------------------------------------------------- core logic -- */

async function addGift() {
  const properties = {};
  properties[CFG.giftProperty] = CFG.giftTag;
  await cartRequest("/cart/add.js", {
    items: [{ id: CFG.variantId, quantity: 1, properties: properties }],
  });
  return verifyGiftIsFree();
}

async function removeGift(key) {
  await cartRequest("/cart/change.js", { id: key, quantity: 0 });
}

/** Der eigentliche Schutz: greift der automatische Rabatt nicht, muss das
 *  Geschenk sofort wieder raus.
 *
 *  Geprueft wird, ob IRGENDEINE Zeile der Geschenk-Variante auf 0 rabattiert ist,
 *  nicht nur die eigene Geschenk-Zeile: kauft der Kunde zusaetzlich eine Flasche,
 *  liegen zwei Zeilen derselben Variante im Korb, und welche davon Shopify
 *  rabattiert, ist nicht zugesichert. Der Kunde zahlt in beiden Faellen dasselbe. */
async function verifyGiftIsFree() {
  const cart = await fetchCart();
  const gift = findGift(cart);
  if (!gift) return false;

  const discounted = (cart.items || []).some(
    (i) => i.variant_id === CFG.variantId && i.final_line_price === 0
  );
  if (discounted) return true;

  await removeGift(gift.key);
  stop("automatischer Rabatt greift nicht (Geschenk-Zeile kostet " + gift.final_line_price + ")");
  return false;
}

async function reconcile(stateCart) {
  if (working || stopped()) return;

  // Grobfilter auf dem Store-Zustand: spart einen /cart.js-Aufruf pro Tick,
  // wenn ohnehin nichts zu tun ist.
  if ((qualifyingCents(stateCart) >= CFG.thresholdCents) === Boolean(findGift(stateCart))) {
    return;
  }

  working = true;
  try {
    // Vor JEDEM Schreiben den Warenkorb frisch vom Server lesen. Der Store-Zustand
    // kann veraltet sein — zweiter Tab, parallele Aenderung, verpasstes Update.
    // Ein Hinzufuegen auf veralteter Grundlage legt dem Kunden eine Flasche in den
    // Korb, die der Rabatt nicht deckt; das Skript wuerde sie zwar sofort wieder
    // entfernen, sich dabei aber fuer die restliche Sitzung abschalten.
    const cart = await fetchCart();
    const gift = findGift(cart);
    const qualifies = qualifyingCents(cart) >= CFG.thresholdCents;

    if (qualifies && !gift) {
      await addGift();
    } else if (!qualifies && gift) {
      await removeGift(gift.key);
    } else {
      return; // Store war veraltet, am Server ist alles in Ordnung
    }

    if (typeof Cart.refresh === "function") await Cart.refresh();
  } catch (err) {
    stop("Warenkorb-Aufruf fehlgeschlagen: " + (err && err.message));
  } finally {
    working = false;
  }
}

/* ---------------------------------------------------------------------- UI -- */

/* Das Aussehen kommt aus den Theme-Klassen der free-shipping-bar, damit der
 * Balken pixelgleich zum Gratis-Versand-Balken sitzt. Hier nur, was das Theme
 * nicht liefert:
 *
 * 1. Der Gradient. Gleiche Machart wie beim Versand-Balken (136deg, Stops bei
 *    11 % und 84 %), aber in unserem Gruen statt Tuerkis-Magenta — so wirken die
 *    zwei Balken als Paar und bleiben doch unterscheidbar.
 * 2. Die Icon-Outline. Das Theme setzt `fill: currentColor` auf `.icon svg`;
 *    ohne Gegenregel rendert die Flasche als schwarze Flaeche statt als
 *    Umrisszeichnung wie der Lieferwagen.
 */
// Gleiche Machart wie der Versand-Gradient (136deg, Stops 11 % / 84 %), nur in
// unserem Gruen. Wird INLINE gesetzt, nicht per Klasse: das Theme setzt
// --track-color selbst inline auf die free-shipping-bar, und ein Inline-Style
// schlaegt jede Klassenregel.
const TRACK_GRADIENT = "linear-gradient(136deg, #1f4b3f 11%, #63d8a6 84%)";

const STYLE = `
.c7-gift-bar .free-shipping-bar__icon svg,
.c7-gift-bar .free-shipping-bar__icon svg *{fill:none;stroke:currentColor}
.c7-gift-bar .c7-gift-bar__done{font-weight:600}
.c7-gift-bar[data-state="reached"] .free-shipping-bar__track{display:none}
`;

function ensureStyle() {
  if (document.getElementById("c7-gift-style")) return;
  const el = document.createElement("style");
  el.id = "c7-gift-style";
  el.textContent = STYLE;
  document.head.appendChild(el);
}

/** Sportflasche als Umrisszeichnung im Stil der Theme-Icons (viewBox 25,
 *  1,4 px Strich, runde Enden) — das Gegenstueck zum Lieferwagen des
 *  Gratis-Versand-Balkens. Deckel, Gewinde, Schulter, Korpus, Fuellstrich. */
const BOTTLE_SVG =
  '<svg aria-hidden="true" focusable="false" role="presentation" ' +
  'xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" fill="none" ' +
  'stroke="currentColor" stroke-width="1.4" stroke-linecap="round" ' +
  'stroke-linejoin="round">' +
  // Deckel
  '<rect x="9.6" y="1.8" width="5.8" height="3.1" rx="1"/>' +
  // Gewindering unter dem Deckel
  '<path d="M10.4 6.6h4.2"/>' +
  // Schultern laufen vom Hals auf den Korpus
  '<path d="M10.4 4.9v1.9c0 .8-.35 1.5-.95 2l-.9.75C7.75 10.3 7.3 11.3 7.3 12.4v7.9c0 1.5 1.25 2.7 2.8 2.7h4.8c1.55 0 2.8-1.2 2.8-2.7v-7.9c0-1.1-.45-2.1-1.25-2.85l-.9-.75c-.6-.5-.95-1.2-.95-2V4.9"/>' +
  // Fuellstrich
  '<path d="M7.3 15.4h10.4"/>' +
  "</svg>";

/** Ein Balken pro Warenkorb-Ansicht (Drawer UND /cart koennen gleichzeitig im
 *  DOM liegen), darum ueber alle Anker iterieren. */
function anchors() {
  const found = [...document.querySelectorAll("free-shipping-bar")];
  if (found.length) return found;
  return [...document.querySelectorAll("[name='checkout'], button[name='checkout']")];
}

function buildBar() {
  const bar = document.createElement("div");
  // Theme-Klassen uebernehmen: gleiche Typografie, Abstaende, Balkenhoehe und
  // Ausrichtung wie beim Gratis-Versand-Balken. "is-visible" setzt beim Theme
  // ein IntersectionObserver — hier direkt, weil der Balken sofort stehen soll.
  bar.className =
    "free-shipping-bar free-shipping-bar--align-left is-visible c7-gift-bar";
  bar.style.setProperty("--track-color", TRACK_GRADIENT);
  bar.innerHTML =
    '<div class="free-shipping-bar__text">' +
    '<span class="free-shipping-bar__icon"><span class="icon icon--selection">' +
    BOTTLE_SVG +
    "</span></span>" +
    '<span class="c7-gift-bar__label"></span>' +
    "</div>" +
    '<div class="free-shipping-bar__track"></div>';
  return bar;
}

function renderBar(cart) {
  if (stopped()) {
    document.querySelectorAll(".c7-gift-bar").forEach((n) => n.remove());
    return;
  }
  ensureStyle();
  const qualifying = qualifyingCents(cart);
  const reached = qualifying >= CFG.thresholdCents;
  const left = Math.max(CFG.thresholdCents - qualifying, 0);
  // Das Theme rechnet mit der RESTdistanz, nicht mit dem Fortschritt: das CSS
  // schneidet den Balken per clip-path um --displacement von rechts weg.
  const displacement = Math.round((left / CFG.thresholdCents) * 100);

  anchors().forEach((anchor) => {
    let bar = anchor.previousElementSibling;
    if (!bar || !bar.classList || !bar.classList.contains("c7-gift-bar")) {
      bar = buildBar();
      anchor.parentNode.insertBefore(bar, anchor);
    }
    bar.setAttribute("data-state", reached ? "reached" : "progress");
    const label = bar.querySelector(".c7-gift-bar__label");
    label.innerHTML = reached
      ? '<span class="c7-gift-bar__done">' + CFG.labelReached + "</span>"
      : CFG.labelProgress.replace("{amount}", "<b>" + money(left) + "</b>");
    bar.querySelector(".free-shipping-bar__track").style.setProperty(
      "--displacement",
      displacement + "%"
    );
  });
}

/* ------------------------------------------------------------------- start -- */

function tick(state) {
  const cart = state && state.cart;
  if (!cart) return;
  renderBar(cart);
  reconcile(cart);
}

if (!outsideWindow()) {
  Cart.subscribe(tick);
  tick(Cart.getState());
  // Der Drawer wird lazy gerendert — bei jedem Öffnen den Balken nachziehen.
  document.addEventListener("click", () => {
    setTimeout(() => renderBar(Cart.getState().cart), 350);
  });
}
